// 1. EVENT LISTENER: Reagiert auf jede Warenkorb-Änderung (Menge hoch/runter, Löschen)
window.addEventListener('theme:cart:updated', (event) => {
    checkAndCleanQuizAttributes(event.detail.cartData);
});

// 2. INITIALER CHECK: Beim Laden der Seite (z.B. nach einem Refresh oder direktem Aufruf)
document.addEventListener('DOMContentLoaded', async () => {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const currentAttributes = cart.attributes;
    if (!currentAttributes || !currentAttributes.quiz_preferences) return;

    let parsedAttribute;
    try {
        parsedAttribute = JSON.parse(currentAttributes.quiz_preferences);
    } catch (e) {
        console.error("Fehler beim Parsen von 'quiz_preferences'.", e);
        return;
    }

    // Verfügbarkeits-Check (GraphQL)
    let allProductsAvailable = true;
    for (const box of parsedAttribute.boxes) {
        for (const meal of box.selectedMeals) {
            const isAvailable = await checkCartStock(meal.variantId);
            if (!isAvailable) {
                allProductsAvailable = false;
            }
        }
    }

    if (!allProductsAvailable) {
        clearCart();
        return;
    }

    // Challenge-Logik
    const isChallenge = parsedAttribute["__biond-challenge"] === true;
    if (isChallenge) {
        clearCart();
    }
});

// URL-Parameter Check für Alerts
document.addEventListener("DOMContentLoaded", () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("item_removed") === "true") {
        if (typeof showAlert === "function") {
            showAlert("Ein oder mehrere Menüs sind nicht mehr verfügbar und wurden entfernt.", "error");
        }
    }
});

// --- HAUPTFUNKTION: SYNCHRONISATION ---

async function checkAndCleanQuizAttributes(cartData) {
    const currentAttributes = cartData.attributes;
    
    // Finde alle Items im Cart, die eine Box-ID in den Properties haben
    const remainingBoxItems = cartData.items.filter(item => item.properties && item.properties["__biond-box-id"]);
    const remainingBoxIds = remainingBoxItems.map(item => String(item.properties["__biond-box-id"]));

    if (!currentAttributes || !currentAttributes.quiz_preferences) return;

    let parsedAttribute;
    try {
        parsedAttribute = JSON.parse(currentAttributes.quiz_preferences);
    } catch (e) { return; }

    const existingBoxes = parsedAttribute.boxes;
    if (!Array.isArray(existingBoxes)) return;

    const surchargeTargets = {}; // Speichert: { "variantId": gesamtMenge }
    const surchargesToForceDelete = [];
    let needsReload = false;

    // 1. Logik-Loop: Berechne wie viele Surcharges im Cart sein MÜSSEN
    existingBoxes.forEach(box => {
        const boxId = String(box["__biond-box-id"]);
        // Finde das zugehörige physische Produkt im Warenkorb
        const actualCartItem = remainingBoxItems.find(item => String(item.properties["__biond-box-id"]) === boxId);

        if (actualCartItem) {
            // BOX IST NOCH DA: Berechne Surcharge (Menge der Box * Menge des Meals)
            box.selectedMeals.forEach(meal => {
                if (meal.hasSpecial && meal.surchargeId) {
                    const boxQty = actualCartItem.quantity;
                    const mealQtyInsideBox = meal.quantity || 1;
                    const totalNeeded = boxQty * mealQtyInsideBox;

                    // Addieren, falls dieselbe Surcharge in mehreren Boxen vorkommt
                    surchargeTargets[meal.surchargeId] = (surchargeTargets[meal.surchargeId] || 0) + totalNeeded;
                }
            });
        } else {
            // BOX WURDE GELÖSCHT: Surcharges dieser Box für Löschung vormerken
            box.selectedMeals.forEach(meal => {
                if (meal.hasSpecial && meal.surchargeId) {
                    surchargesToForceDelete.push(meal.surchargeId);
                }
            });
        }
    });

    // 2. Abgleich mit dem aktuellen Cart-Inhalt
    const updates = {};

    // Prüfe alle Items, die bereits im Cart liegen
    cartData.items.forEach(item => {
        const vId = String(item.variant_id);
        if (surchargeTargets[vId] !== undefined) {
            // Wenn die Menge im Cart nicht der berechneten Soll-Menge entspricht -> Update
            if (item.quantity !== surchargeTargets[vId]) {
                updates[vId] = surchargeTargets[vId];
            }
            delete surchargeTargets[vId]; // Von der Liste "Neu Hinzuzufügen" streichen
        }
    });

    // Neue Surcharges hinzufügen (die noch gar nicht im Cart sind)
    for (const [vId, qty] of Object.entries(surchargeTargets)) {
        updates[vId] = qty;
    }

    // Gelöschte Surcharges auf 0 setzen (falls sie nicht von einer anderen Box genutzt werden)
    surchargesToForceDelete.forEach(vId => {
        if (!updates[vId] && !remainingBoxItems.some(item => String(item.variant_id) === vId)) {
             // Nur auf 0 setzen, wenn keine Soll-Menge existiert
             updates[vId] = 0;
        }
    });

    // 3. Ausführung der Updates
    
    // A) Physische Mengen im Cart korrigieren
    if (Object.keys(updates).length > 0) {
        console.log("Synchronisiere Surcharges:", updates);
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });
        needsReload = true;
    }

    // B) Attribute (quiz_preferences) bereinigen
    const cleanedBoxes = existingBoxes.filter(box => remainingBoxIds.includes(String(box["__biond-box-id"])));
    if (cleanedBoxes.length !== existingBoxes.length) {
        const newAttributes = {
            quiz_preferences: cleanedBoxes.length > 0 ? JSON.stringify({ boxes: cleanedBoxes }) : null
        };
        await updateCartAttributes(newAttributes);
        needsReload = true;
    }

    if (needsReload) {
        location.reload();
    }
}

// --- HILFSFUNKTIONEN ---

async function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
    }).then(res => res.json());
}

async function checkCartStock(variantId) {
    const query = `query GetVariantByID {
        node(id: "gid://shopify/ProductVariant/${variantId}") {
            ... on ProductVariant {
                product { availableForSale }
            }
        }
    }`;
    try {
        const response = await fetch('https://jw9wdd-tu.myshopify.com/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '22d24b254e1f56c5770f0671863f6a97'
            },
            body: JSON.stringify({ query })
        });
        const json = await response.json();
        return json.data?.node?.product?.availableForSale || false;
    } catch (e) { return false; }
}

function clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
    .then(() => updateCartAttributes({ "quiz_preferences": null }))
    .then(() => { document.location.href = '/cart?item_removed=true'; });
}